import { render, staticRenderFns } from "./CourseRequirementMaintenance.vue?vue&type=template&id=32f76450&scoped=true"
import script from "./CourseRequirementMaintenance.vue?vue&type=script&lang=js"
export * from "./CourseRequirementMaintenance.vue?vue&type=script&lang=js"
import style0 from "./CourseRequirementMaintenance.vue?vue&type=style&index=0&id=32f76450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f76450",
  null
  
)

export default component.exports